import { Subscription, SubscriptionLike, TeardownLogic } from 'rxjs';

/**
 * Proxy for Subscription that allows setter to allow inline use without extra brackets
 * or extra local variable
 *
 * private sub = new SubscriptionSink();
 * [...]
 * this.sub.sink = someObservable$.subscribe(...);
 * [...]
 * this.sub.unsubscribe();
 */
export class SubscriptionSink implements SubscriptionLike {
  public closed: boolean;
  private sub = new Subscription();
  private subs = new Set<TeardownLogic>();

  /**
   * add an inner subscription
   */
  public set sink(s: SubscriptionLike) {
    if (s == null) {
      return;
    }
    this.sub.add(s);
  }

  /**
   * For backwards compatibility
   *
   * @param s typically a subscription
   */
  public add(s: TeardownLogic): void {
    if (this.subs.has(s)) {
      return;
    }
    this.sub.add(s);
  }

  /**
   * Unsubscribe all inner subscriptions
   */
  public unsubscribe(): void {
    this.sub.unsubscribe();
    this.subs = null;
    this.closed = true;
  }
}
